import { Box } from '@mui/material';
import React from 'react';
import AboutTitle from '../AboutTitle/AboutTitle';
import Services from '../Services/Services';

const Luminous = () => {
  return (
    <Box>
      <AboutTitle />
      <Services />
    </Box>
  );
};

export default Luminous;